<template>
<div>
   <Breadcrumb> 
            <span><router-link :to="{ path:'/'}">Početna</router-link></span>
            <span class="separetor">/</span>
            <span class="font-weight-bolder"><router-link :to="{ name:'o-nama'}">O nama</router-link></span>
     </Breadcrumb>
    <section class="has-sidebar u-padding-tb-40">
            <div class="container">
                <div class="row" data-sticky_parent>
                    <div class="col-lg-12 content-wrapper">
                        <div data-sticky_column>
                            <div class="contact-form">
                                <div class="form-title">
                                    <h4>O nama</h4>
                                </div>
                                <div class="form-body">
                                    <div class="m-post-content">
                                      <div class=" entry-content">
                                         <p class="font-weight-bold">{{ about.textShort}}</p>
                                          <div v-if="aboutInfo && aboutInfo.absolutePhotoUrl" class="aboutus-photo u-margin-t-20 u-margin-b-20">
                                            <img v-lazy="aboutInfo.absolutePhotoUrl" alt="About Us Photo">
                                        </div>
                                         <p> {{ about.text }}</p>
                                           <div class="widget widget--border-box social-grid">
                            <div class="widget__title">
                                <h4>Pratite nas na društvenim mrežama</h4>
                            </div>
                            <div class="list-wrap">
                                <ul class="media-lists social--color">
                                    <li>
                                        <a class="social__facebook" v-bind:href="about.facebookPage" target="_blank">
                                            <div class="media__inner">
                                                <i class="fa fa-facebook"></i>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="social__twitter media__inner" v-bind:href="about.twitterPage" target="_blank">
                                            <div class="media__inner">
                                                <i class="fa fa-twitter"></i>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="social__instagram media__inner" v-bind:href="about.instagramPage" target="_blank">
                                            <div class="media__inner">
                                                <i class="fa fa-instagram"></i>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="social__youtube media__inner" v-bind:href="about.youtubeChannel" target="_blank">
                                            <div class="media__inner">
                                                <i class="fa fa-youtube"></i>
                                            </div>
                                        </a>
                                    </li>  
                                </ul>
                            </div>
                        </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </div>     
 </template>

<script>
    import { AboutService } from '../common/api.service'
    import Breadcrumb from '../components/Breadcrumb'

    export default {
        name: "About",
        components: { Breadcrumb },
        metaInfo: {
            title: 'O nama',        
        },
        data() {
            return {
                about: {}
            }
        },
            mounted() {
                window.scrollTo(0, 0);
            },
        created() {
            this.fetchData();
        },
        methods: {
            fetchData: function() {
                AboutService.getAboutInfo().then(res => this.about = res.data);
            }
        }
    }
</script>

<style scoped>
    .widget--border-box.social-grid .media-lists li {
        flex: 0 0 25.000%;
        -webkit-flex: 0 0 25.000%;
        -ms-flex: 0 0 25.000%;
    }

      .aboutus-photo img {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 700px;
    }
</style>


// WEBPACK FOOTER //
// src/components/About.vue